import $ from "jquery";

let i18 = {
    "pl": {
        "Username changed": "Nazwa zmieniona"
    }
}

function t(message) {
    if (lang === "en") return message;
    if (lang === "pl") return i18['pl'][message] ? i18['pl'][message] : message;
}

let lang = document.documentElement.getAttribute("lang").toLowerCase() === "pl" ? "pl" : "en";

var GPPYChangeUsername = {
    init: function() {
        $('.changeUsername a').click(GPPYChangeUsername.changeUsername)
    },

    changeUsername: function() {
        var username = $('#loginFormNewUsername').val();
        $('.changeUsernameErrors').html('').addClass("hidden");
        Promise.resolve($.post('/api/changeMyUsername/', {
            'username' : username
        })).then(
            GPPYChangeUsername.changed,
            GPPYChangeUsername.showError)

    },

    showError: function(res) {
        var processErrors = function(errors, target) {
            var errorshtml = errors.map(function(el){return '<span class="help-block">'+el+'</span>'});
            errorshtml =  errorshtml.reduce(function(con, el){return con+el},"");
            target.html(errorshtml).removeClass("hidden").addClass("has-error");
        }

        var errs = res.responseJSON.form_errors;
        processErrors(errs,$('.changeUsernameErrors'));
    },

    changed: function() {
        $('.changeUsernameErrors').html(t("Username changed")).removeClass("hidden").removeClass("has-error");
    }
}

$('document').ready(GPPYChangeUsername.init);

